import React from 'react';
import { createBrowserRouter, RouterProvider } from 'react-router-dom';
import { RootLayout } from './layouts/RootLayout';
import {
  Home,
  Disclaimer,
  Privacy,
  Terms,
  Regimens,
  IntakeRecords,
  SuggestedDosages,
  ContributeInfo,
  CurrentPlans,
  BuyPeptides
} from './pages';
import { Calendar } from './pages/Calendar';

const router = createBrowserRouter([
  {
    path: '/',
    element: <RootLayout />,
    children: [
      { index: true, element: <Home /> },
      { path: 'disclaimer', element: <Disclaimer /> },
      { path: 'peptides', element: <BuyPeptides /> },
      { path: 'privacy', element: <Privacy /> },
      { path: 'contribute', element: <ContributeInfo /> },
      { path: 'terms', element: <Terms /> },
      { path: 'regimens', element: <Regimens /> },
      { path: 'intake', element: <IntakeRecords /> },
      { path: 'dosages', element: <SuggestedDosages /> },
      { path: 'plans', element: <CurrentPlans /> },
      { path: 'calendar', element: <Calendar /> },
    ],
  },
]);

export default function App() {
  return <RouterProvider router={router} />;
}